import type {
  MRT_ColumnDef,
  MRT_ColumnFiltersState,
  MRT_RowData
} from "mantine-react-table-open";

/** Keeps only the column filters whose column exists and whose value fits that column's filter input. */
export function dropInvalidColumnFilters<TData extends MRT_RowData>(
  columnFilters: MRT_ColumnFiltersState,
  columns: Array<MRT_ColumnDef<TData>>
): MRT_ColumnFiltersState {
  return columnFilters.filter((filter) => {
    const column = columns.find((column) => getColumnId(column) === filter.id);
    if (!column) {
      return false;
    }

    if (column.filterVariant === "multi-select") {
      return (
        Array.isArray(filter.value) &&
        filter.value.every((item) => typeof item === "string")
      );
    }

    if (column.Filter) {
      return true;
    }

    return typeof filter.value === "string";
  });
}

function getColumnId<TData extends MRT_RowData>(column: MRT_ColumnDef<TData>) {
  return (
    column.id ??
    column.accessorKey?.toString() ??
    (typeof column.header === "string" ? column.header : undefined)
  );
}
